import request from "@/utils/request";

//登录
export function getSTS() {
  return request({
    url: "/api/agent/sts",
    method: "get"
  });
}
